import { createFileRoute } from '@tanstack/react-router';
import Permissions from '../../../administration/src/components/MetaSites/MetaSiteDetails/Permissions';

export const Route = createFileRoute('/_secured/administration/meta-sites/$metaSiteId/permissions')({
  component: Permissions,
});
